import { TravelPlanDetails } from "../api/travelPlan";
import dayjs from "dayjs";
import "dayjs/locale/sv";
dayjs.locale("sv");

/* RouteLinkGroupType To  LineTypeName */
const inferLineType = (link: any): string => {
  const group = link.RouteLinkGroupType?.toUpperCase();

  switch (group) {
    case "GRPGÅNG":
      return "GÅNG";
    case "GRPTÅG":
      return "TÅG";
    case "GRPBÅT":
      return "BÅT";
    case "GRPTÄTO":
      return "TÄTO";
    case "GRPLAND":
      return "LAND";
    case "GRPEXPRESS":
      return "EXPRESS";
    case "GRPNÄRTRAFIK":
      return "NÄRTRAFIK";
    default:
      if (link.LineName?.toLowerCase().includes("gång")) return "GÅNG";
      if (/^\d+$/.test(link.LineNrReal?.toString())) return "BUSS";
      return "TÅG";
  }
};


/* Match LineTypeName to OGT-Traffic-data */
const getOgtTrafficData = (type: string) => {
  switch (type) {
    case "TÅG":
      return {
        OgtTrafficTypeGroupCssClass: "Tågtrafik",
        OgtTrafficTypeIconCssClass: "ogt-service-train",
        OgtTrafficTypeIconReplaceLineName: true,
      };
    case "BUSS":
      return {
        OgtTrafficTypeGroupCssClass: "Busstrafik",
        OgtTrafficTypeIconCssClass: "ogt-service-bus",
        OgtTrafficTypeIconReplaceLineName: true,
      };
    case "GÅNG":
      return {
        OgtTrafficTypeGroupCssClass: "Gångtrafik",
        OgtTrafficTypeIconCssClass: "ogt-service-walk",
        OgtTrafficTypeIconReplaceLineName: true,
      };
    case "BÅT":
      return {
        OgtTrafficTypeGroupCssClass: "Båttrafik",
        OgtTrafficTypeIconCssClass: "ogt-service-boat",
        OgtTrafficTypeIconReplaceLineName: true,
      };
    default:
      return {
        OgtTrafficTypeGroupCssClass: "Okänd",
        OgtTrafficTypeIconCssClass: "ogt-service-unknown",
        OgtTrafficTypeIconReplaceLineName: false,
      };
  }
};

/* format date / time */
const formatDateReadable = (isoDate: string) =>
  dayjs(isoDate).format("dddd D MMMM");

const formatTimeRange = (start: string, end: string) =>
  `${dayjs(start).format("HH:mm")} - ${dayjs(end).format("HH:mm")}`;

const mapPartialJourney = (journey: any): TravelPlanDetails["selectedJourney"] => {
  const fullLine = (journey.RouteLinks || []).map((link: any) => {
    const type = inferLineType(link);
    return {
      Line: {
        LineName: link.LineName,
        LineTypeName: type,
        Ogt: getOgtTrafficData(type),
      },
      StopIds: link.StopIds || [],
    };
  });

  /* filter out walk and empty lines */ 
  const realConnections = fullLine.filter(
    (segment: { Line: any; StopIds: any[] }) =>
      segment.Line.LineTypeName !== "GÅNG" &&
      segment.StopIds &&
      segment.StopIds.length > 0
  );

  return {
    fromName: journey.From?.PlaceName || "",
    toName: journey.To?.PlaceName || "",
    date: formatDateReadable(journey.DateOfJourney),
    unformattedDate: journey.DateOfJourney,
    travelTime: formatTimeRange(journey.DateOfJourney, journey.ArrivalDateOfJourney),
    switches: realConnections.length > 1 ? realConnections.length - 1 : 0,
    line: fullLine.map((l: { Line: any; StopIds: any[] }) => ({ Line: l.Line })),
};
};

export function mapApiDataToTravelPlanDetails(apiData: any): TravelPlanDetails {
  const [firstJourney, secondJourney] = apiData.PartialJourneys;

  return {
    ReferenceId: apiData.ReferenceId || "",
    EditId: apiData.EditId || "",
    email: apiData.Email || "",
    selectedJourney: mapPartialJourney(firstJourney),
    selectedReturnJourney: secondJourney ? mapPartialJourney(secondJourney) : undefined,
  };
}
